// {
//   "name": "iconic-video-slider.js",
//   "author": "Arham Web Works"
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(() => {
  if (customElements.get('iconic-video-slider')) {
    return;
  }

  class IconicVideoSlider extends HTMLElement {
    constructor() {
      super();
      this.initVideoEvent = this.initVideoEvent.bind(this);
      this.autoplayActiveSlideVideo = this.autoplayActiveSlideVideo.bind(this);
    }

    connectedCallback() {
      this.layout = this.getAttribute('data-layout'); 
      this.column = this.getAttribute('data-column'); 
      this.autoplay = this.getAttribute('data-autoplay'); 
      this.initVideoEvent();

      window.addEventListener('load', () => {
        this.autoplayActiveSlideVideo();
      });

      const swipers = document.querySelectorAll('.iconic-video-swiper');
      swipers.forEach((swiper) => {
        swiper.addEventListener('transitionend', this.autoplayActiveSlideVideo);
      });
    }

    initVideoEvent() {
      const toggleVideo = (video, playIcon, pauseIcon, play = true) => {
        play ? video.play() : video.pause();
        playIcon.style.display = play ? 'none' : 'block';
        pauseIcon.style.display = play ? 'block' : 'none';
      };

      const toggleMute = (video, muteIcon, unmuteIcon, mute = true) => {
        video.muted = mute;
        muteIcon.style.display = mute ? 'block' : 'none';
        unmuteIcon.style.display = mute ? 'none' : 'block';
      };

      const handleClick = (buttons, type) => {
        buttons.forEach((button) => {
          button.addEventListener('click', () => {
            const videoContainer = button.closest('.iconic-video-gallery-item');
            const videoTag = videoContainer.querySelector('video');
            const playIcon = videoContainer.querySelector('.iconic-slider-video-play');
            const pauseIcon = videoContainer.querySelector('.iconic-slider-video-push');
            const muteIcon = videoContainer.querySelector('.iconic-video-mute');
            const unmuteIcon = videoContainer.querySelector('.iconic-video-unmute');

            if (type === 'play') {
              // Pause other videos
              this.querySelectorAll('video').forEach((otherVideo) => {
                if (otherVideo !== videoTag && !otherVideo.paused) {
                  const otherContainer = otherVideo.closest('.iconic-video-gallery-item');
                  toggleVideo(
                    otherVideo,
                    otherContainer.querySelector('.iconic-slider-video-play'),
                    otherContainer.querySelector('.iconic-slider-video-push'),
                    false
                  );
                }
              });
              // Play current video
              toggleVideo(videoTag, playIcon, pauseIcon, true);
            } else if (type === 'pause') {
              toggleVideo(videoTag, playIcon, pauseIcon, false);
            } else if (type === 'mute') {
              toggleMute(videoTag, muteIcon, unmuteIcon, !videoTag.muted);
            } else if (type === 'unmute') {
              toggleMute(videoTag, muteIcon, unmuteIcon, true);
            }
          });
        });
      };

      handleClick(this.querySelectorAll('.iconic-slider-video-play'), 'play');
      handleClick(this.querySelectorAll('.iconic-slider-video-push'), 'pause');
      handleClick(this.querySelectorAll('.iconic-video-mute'), 'mute');
      handleClick(this.querySelectorAll('.iconic-video-unmute'), 'unmute');
    }

    autoplayActiveSlideVideo() {
      const swipers = document.querySelectorAll('.iconic-video-swiper');

      swipers.forEach((swiperEl) => {
        // Get the active slide in the current Swiper
        const activeSlide = swiperEl.querySelector('.swiper-slide-active');
        if (!activeSlide) {
          return;
        }

        // Pause all videos in the Swiper
        const videos = swiperEl.querySelectorAll('video');
        videos.forEach((video) => {
          video.pause();
        });

        // Play the video in the active slide
        const activeVideo = activeSlide.querySelector('video');
        if (activeVideo) {
          activeVideo.play();
        } else {
        }
      });
    }
  }

  customElements.define('iconic-video-slider', IconicVideoSlider);
})();




